import React from "react";

export const Loader = props => {
  const className = props.button ? "loader loader--button" : "loader";

  return (
    <div className={className}>
      <div className="loader__dots" />
    </div>
  );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/shared/Loader.js